import { VUserExistRequest, VUserExistResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class AccountExistsEndpoint extends EncryptedEndpoint {
    async getRequestInit({ emails }) {
        const requestBytes = VUserExistRequest.encode({
            userId: emails
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VUserExistResponse.decode(responseBytes);
    }
}
export const accountExistsEndpoint = new AccountExistsEndpoint({
    path: '/identity/accounts/exists',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VUserExistResponse
});
